/**
 * @generated SignedSource<<849d4ba95e085db06c3756045c4d76f4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProposalVotesSummaryVoteTimeFragment$data = {
  readonly voteEndsAt: number;
  readonly voteStartsAt: number;
  readonly " $fragmentType": "ProposalVotesSummaryVoteTimeFragment";
};
export type ProposalVotesSummaryVoteTimeFragment$key = {
  readonly " $data"?: ProposalVotesSummaryVoteTimeFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProposalVotesSummaryVoteTimeFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProposalVotesSummaryVoteTimeFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "voteStartsAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "voteEndsAt",
      "storageKey": null
    }
  ],
  "type": "OnChainProposal",
  "abstractKey": null
};

(node as any).hash = "ac51e1fc2db9f7493def3747316058bb";

export default node;
